// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StartGame_wrapper__1AI3d","mainImg":"StartGame_mainImg__yPDj0"};